import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
    selector: 'app-popup',
    templateUrl: './popup.component.html',
    styleUrls: ['./popup.component.scss'],
    standalone: false
})
export class PopupComponent {
    constructor(
        private readonly _router: Router,
        @Inject(MAT_DIALOG_DATA) private readonly data?: { signUp?: boolean }
    ) {
        const path = this.data?.signUp ? 'sign-up' : 'sign-in';
        this._router.navigate([{ outlets: { auth: [path] } }], {
            skipLocationChange: true
        });
    }
}
